var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"snack-bar",class:_vm.variant},[_vm._t("primary"),_vm._v(" "),_vm._t("secondary")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }